module.exports = __webpack_public_path__ + "02_mole.5f59a2ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/02_mole.png
// module id = W5r7
// module chunks = 0